import type { ApiClient } from './client.js';
import type { BirthdayDto, CalendarEventDto } from './types.js';

export interface CreateEventBody {
  eventDate: string;
  title: string;
}

export interface CreateBirthdayBody {
  name: string;
  month: number;
  day: number;
}

export interface CalendarApi {
  listEvents(classroomId: string, from?: string, to?: string): Promise<CalendarEventDto[]>;
  createEvent(classroomId: string, body: CreateEventBody): Promise<CalendarEventDto>;
  removeEvent(classroomId: string, eventId: string): Promise<void>;
  listBirthdays(classroomId: string): Promise<BirthdayDto[]>;
  createBirthday(classroomId: string, body: CreateBirthdayBody): Promise<BirthdayDto>;
  removeBirthday(classroomId: string, birthdayId: string): Promise<void>;
  clearBirthdays(classroomId: string): Promise<{ removed: number }>;
}

export function createCalendarApi(client: ApiClient): CalendarApi {
  return {
    async listEvents(classroomId, from, to) {
      const params = new URLSearchParams();
      if (from) params.set('from', from);
      if (to) params.set('to', to);
      const qs = params.toString();
      const path = qs
        ? `/api/classrooms/${classroomId}/events?${qs}`
        : `/api/classrooms/${classroomId}/events`;
      const res = await client.get<{ events: CalendarEventDto[] }>(path);
      return res.events;
    },
    async createEvent(classroomId, body) {
      const res = await client.post<{ event: CalendarEventDto }>(
        `/api/classrooms/${classroomId}/events`,
        body,
      );
      return res.event;
    },
    async removeEvent(classroomId, eventId) {
      await client.delete(`/api/classrooms/${classroomId}/events/${eventId}`);
    },
    async listBirthdays(classroomId) {
      const res = await client.get<{ birthdays: BirthdayDto[] }>(
        `/api/classrooms/${classroomId}/birthdays`,
      );
      return res.birthdays;
    },
    async createBirthday(classroomId, body) {
      const res = await client.post<{ birthday: BirthdayDto }>(
        `/api/classrooms/${classroomId}/birthdays`,
        body,
      );
      return res.birthday;
    },
    async removeBirthday(classroomId, birthdayId) {
      await client.delete(`/api/classrooms/${classroomId}/birthdays/${birthdayId}`);
    },
    async clearBirthdays(classroomId) {
      return client.delete<{ removed: number }>(`/api/classrooms/${classroomId}/birthdays`);
    },
  };
}
